(function () {
  if (customElements.get("quantity-breaks")) return;

  class QuantityBreaks extends HTMLElement {
    connectedCallback() {
      this.radios = Array.from(this.querySelectorAll('input[type="radio"][name="quantity"]'));
      this.variantSelects = Array.from(this.querySelectorAll(".quantity-break__variant-select"));
      this.variantMediaButtons = Array.from(this.querySelectorAll(".quantity-break__variant-media-button"));
      this.variants = this.readVariants();
      this.form = this.resolveForm();
      this.radios.forEach((radio) => radio.addEventListener("change", () => this.handleQuantityChange(radio)));
      this.variantSelects.forEach((select) => select.addEventListener("change", (event) => this.handleVariantChange(event)));
      this.variantMediaButtons.forEach((button) => button.addEventListener("click", (event) => this.handleVariantMediaClick(event)));
      this.radios.forEach((radio) => {
        if (!radio.checked) return;
        this.handleQuantityChange(radio);
      });
    }

    readVariants() {
      const json = this.querySelector('script[type="application/json"]');
      if (!json) return [];
      try {
        return JSON.parse(json.textContent || "[]");
      } catch (_error) {
        return [];
      }
    }

    resolveForm() {
      const checked = this.querySelector('input[type="radio"][name="quantity"]:checked') || this.radios[0];
      if (checked && checked.getAttribute("form")) {
        return document.getElementById(checked.getAttribute("form"));
      }
      return this.closest("form") || document.querySelector('form[action*="/cart/add"]');
    }

    handleQuantityChange(radio) {
      this.selectedQuantity = Number(radio.value || 1);
      this.updateHostQuantity(this.selectedQuantity);
      this.updateAtcPrice(this.getBreakForRadio(radio));
      this.dispatchEvent(
        new CustomEvent("quantity-breaks:change", {
          bubbles: true,
          detail: {
            quantity: this.selectedQuantity,
            input: radio.dataset.input,
          },
        }),
      );
    }

    updateHostQuantity(quantity) {
      if (!this.form) return;
      const formQuantity = this.form.querySelector('input[name="quantity"]:not([type="radio"])');
      if (formQuantity) formQuantity.value = String(quantity);
    }

    handleVariantMediaClick(event) {
      event.preventDefault();
      const button = event.currentTarget;
      const variants = button.closest(".quantity-break__variants");
      if (!variants) return;
      variants.querySelectorAll(".quantity-break__variant-media-button").forEach((mediaButton) => {
        mediaButton.classList.toggle("is-active", mediaButton === button);
      });
      variants.querySelectorAll(".quantity-break__selector-item").forEach((item) => {
        const firstSelect = item.querySelector(".quantity-break__variant-select");
        if (!firstSelect) return;
        firstSelect.value = button.dataset.optionValue || firstSelect.value;
        firstSelect.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }

    handleVariantChange(event) {
      const item = event.target.closest(".quantity-break__selector-item");
      if (!item) return;
      const selectedOptions = Array.from(item.querySelectorAll("select")).map((select) => select.value);
      const variant = this.variants.find((candidate) => {
        if (!candidate.options) return false;
        return candidate.options.every((option, index) => selectedOptions[index] === option);
      });
      if (!variant) return;
      item.dataset.selectedId = variant.id;
      event.target.dataset.productId = variant.id;
      this.updateActiveVariantMedia(item, variant.options && variant.options[0]);
      this.updateMedia(variant);
      const option = event.target.closest(".quantity-break");
      this.updateVariantPrices(option, variant);
      if (option && this.isBreakSelected(option)) {
        this.updateAtcPrice(option);
      }
    }

    updateMedia(variant) {
      if (!variant || !variant.featured_media || !this.dataset.section) return;
      document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`).forEach((gallery) => {
        if (typeof gallery.setActiveMedia === "function") {
          gallery.setActiveMedia(`${this.dataset.section}-${variant.featured_media.id}`, true);
        }
      });
    }

    updateActiveVariantMedia(item, optionValue) {
      if (!item || !optionValue) return;
      const variants = item.closest(".quantity-break__variants");
      if (!variants) return;
      variants.querySelectorAll(".quantity-break__variant-media-button").forEach((button) => {
        button.classList.toggle("is-active", button.dataset.optionValue === optionValue);
      });
    }

    updateVariantPrices(option, variant) {
      if (!option || this.dataset.updatePrices !== "true") return;
      const quantity = Number(option.dataset.quantity || 1);
      const percentageLeft = Number(option.dataset.percentageLeft || 1);
      const fixedDiscount = Number(option.dataset.fixedDiscount || 0);
      const compareBase = variant.price;
      const price = variant.price * quantity * percentageLeft - fixedDiscount;
      const comparePrice = compareBase * quantity;
      const saved = comparePrice - price;
      const values = {
        "[quantity]": quantity,
        "[price]": this.formatMoney(price),
        "[compare_price]": this.formatMoney(comparePrice),
        "[amount_saved]": this.formatMoney(saved),
        "[amount_saved_rounded]": this.formatMoney(Math.ceil(saved / 100) * 100),
        "[price_each]": this.formatMoney(price / quantity),
        "[compare_price_each]": this.formatMoney(comparePrice / quantity),
      };
      option.querySelectorAll(".variant-price-update").forEach((node) => {
        let text = node.dataset.text || "";
        Object.keys(values).forEach((key) => {
          text = text.replaceAll(key, values[key]);
        });
        node.innerHTML = text;
      });
      const compare = option.querySelector(".quantity-break__compare-price");
      if (compare) compare.classList.toggle("hidden", comparePrice <= price);
    }

    updateAtcPrice(option) {
      if (!option) return;
      const priceNode = option.querySelector(".quantity-break__price span") || option.querySelector(".quantity-break__price");
      const atcPrice = document.querySelector(`#main-atc-price-${this.dataset.section}`);
      if (!priceNode || !atcPrice) return;
      atcPrice.textContent = `${priceNode.textContent.trim()} •`;
    }

    getBreakForRadio(radio) {
      if (!radio || !radio.id) return null;
      return Array.from(this.querySelectorAll("label.quantity-break")).find((label) => label.getAttribute("for") === radio.id) || null;
    }

    isBreakSelected(option) {
      if (!option || !option.getAttribute("for")) return false;
      const radio = document.getElementById(option.getAttribute("for"));
      return Boolean(radio && radio.checked);
    }

    formatMoney(cents) {
      const value = Number(cents || 0) / 100;
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: "currency",
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD",
      }).format(value).replace(/\.00$/, "");
    }
  }

  customElements.define("quantity-breaks", QuantityBreaks);
})();
